// Maintain the query strings in the url on the client side performing an action, for example, when the user clicks on the changing the grid on product list or pagination

const createQueryString = (paramsToUpdate, searchParams) => {
  const params = new URLSearchParams(searchParams.toString());

  Object.entries(paramsToUpdate).forEach(([key, value]) => {
    params.set(key, value);
  });

  return params.toString();
};

export default createQueryString;
